import { setStoredWorkModule } from "@/modules/workModuleCore";
import { resolveWorkModuleForDatosMaestrosCard } from "@/modules/datosMaestros/datosMaestrosNavigation";

/**
 * Persiste y notifica el módulo de trabajo correcto al abrir una tarjeta DM.
 * @param {string} cardPath
 * @returns {string|null} moduleId aplicado
 */
export function applyDatosMaestrosWorkModule(cardPath) {
  const moduleId = resolveWorkModuleForDatosMaestrosCard(cardPath);
  if (!moduleId) return null;
  setStoredWorkModule(moduleId);
  try {
    window.dispatchEvent(
      new CustomEvent("visor:work-module-changed", {
        detail: { moduleId },
      }),
    );
  } catch {
    /* ignore */
  }
  return moduleId;
}
